<template>
  <div>
    <el-upload
          v-if="imageUrl==''"
          :http-request="httpRequest"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          accept=".jpg,.jpeg,.png"
          :before-upload="beforeAvatarUpload"
          :on-change="onChange"
          :limit="limitCount"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，单个文件小于2m</div>
        </el-upload>
        <ul class="el-upload-list el-upload-list--picture-card" v-show="imageUrl!=''">
          <li  class="el-upload-list__item is-ready" >
            <img :src="imageUrl" alt="" class="el-upload-list__item-thumbnail" /><a
              href=""
              class="el-upload-list__item-name"
              ><i class="el-icon-document"></i
            ></a>
            <label class="el-upload-list__item-status-label"
              ><i class="el-icon-upload-success el-icon-check"></i
            ></label>
            <i class="el-icon-close"></i><i class="el-icon-close-tip"></i
            ><span class="el-upload-list__item-actions"
              ><span class="el-upload-list__item-preview" @click="previewImg"
                ><i class="el-icon-zoom-in"></i></span
              ><span class="el-upload-list__item-delete" @click="deleteImg"
                ><i class="el-icon-delete"></i></span
            ></span>
          </li>
        </ul>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true"
          ><img width="100%" :src="imageUrl" alt=""/></el-dialog>
  </div>
</template>
<script>
import { putFile, downloadFile } from '@/api/crmedical/contract/add';
export default {
  name: 'shareConfig',
  props: { 
    imageUrl: {}, 
  },
  data() {
    return {
   
    dialogVisible: false, 
    limitCount: 1, 
    hideUpload: true,
   
   };
  },
  created() {
    console.log("********",this.imageUrl)
  },
  methods: {
    httpRequest(file) {
        let fd = new FormData();
        fd.append('file', file.file);
        putFile(fd, { timeout: 120000 })
          .then((res) => {
           this.imageUrl = res.data.link
           this.$emit('update:imageUrl', this.imageUrl);
          })
          .catch((err) => {});
      },
   
    // 预览图片
    previewImg() {this.dialogVisible = true},
    // 删除图片
    deleteImg() {
      this.imageUrl = ''
      this.$emit('update:imageUrl', this.imageUrl);
      this.hideUpload = true;
      this.$forceUpdate()
  },
    upload() {},
    onChange(file, fileList) {
      if (fileList.length >= this.limitCount) {
        this.hideUpload = false;
      }
      console.log("********")
      // this.getBase64(file.raw).then((res) => {
      //   const params = res.split(',');
      //   if (params.length > 0) {
      //     this.imageUrl = params[0] + ',' + params[1];
      //   }
      // });
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG /png格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      // this.imageUrl = ''
      this.hideUpload = true
    },
    handlePictureCardPreview(file) {
      this.imageUrl = file.urlthis.dialogVisible = true;
    }, // 获取图片转
    base64getBase64(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader();
        let imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
  },
};
</script>
<style scoped></style>
